import React, { createContext, useContext, useEffect, useState } from "react";

import { getActions, getConnection } from "./db";
const ObservationCreateContext = createContext({});

const IndexedDBProvider = (props) => {
	const [isInitialized, setIsInitialized] = useState(false);

	useEffect(() => {
		getConnection(props.config).then(() => setIsInitialized(true));
	}, [props.config]);

	return isInitialized ? (
		<ObservationCreateContext.Provider
			value={{ config: props.config, actions: getActions }}
		>
			{props.children}
		</ObservationCreateContext.Provider>
	) : (
		props.loading || null
	);
};

export function useIndexedDBStore(storeName) {
	const ctx = useContext(ObservationCreateContext);
	return ctx.actions(storeName, ctx.config);
}

export default IndexedDBProvider;
